export default "/images/icloud.png?e50fdef60ff1b86d3c3cb77f2020fdf0";